<nz-card class="rounded mt-3 p-4 mb-3" nzHoverable>
  <nz-skeleton *ngIf="loading" [nzLoading]="loading" [nzActive]="true"></nz-skeleton>
  <div *ngIf="!loading" class="d-flex flex-column">
    <div class="title">Webhook Shipping Delivery</div>
    <span>
      A webhook is an automatic link between apps, sending data instantly when a specific event occurs. It enables real-time updates without manual checks
    </span>
  </div>
  <div class="position-relative mt-3 rounded" [ngStyle]="{'height': isGetWebhook ? '' : '350px'}">
    <nz-list *ngIf="!listWebhook" [nzDataSource]="[]"></nz-list>

    <form *ngIf="listWebhook" [formGroup]="formGroupWebhook">
      <div class="form-group mt-3 d-flex flex-column col-12">
        <label for="url">Webhook URL:</label>
        <div class="col-12 d-flex flex-column">
          <nz-input-group nzSize="large" [nzSuffix]="suffixTemplate" [nzStatus]="isValidURL ? '' : 'error'">
            <input
              nz-input
              nzSize="large"
              formControlName="url"
              placeholder="Enter the URL where webhook notifications will be sent"
              (keydown.enter)="$event.preventDefault()"
              (input)="setValueRuleWebhook()"
            />
          </nz-input-group>
          <ng-template #suffixTemplate>
            <img
              *ngIf="listWebhook"
              src="https://storage.googleapis.com/komerce/assets/icons/edit.svg"
              alt="edit"
              width="20px"
              style="cursor: pointer;"
              [ngStyle]="{'opacity': isEditMode ? '0.5' : '1'}"
              (click)="toggleEdit()"
            />
          </ng-template>
        </div>
      </div>

      <div class="mt-1 d-flex align-items-center col-12">
        <div class="col-lg-2 col-sm-0"></div>
        <span class="text-danger">
          <img
            *ngIf="errPN !== ''"
            src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
            alt="warning"
            style="max-width: 10px; max-height: 10px"
          />
          {{ errPN }}
        </span>
      </div>
    </form>

    <div class="mt-3 d-flex justify-content-end">
      <button *ngIf="!listWebhook" class="btn btn-primary text-white" (click)="addWebhook()">
        Add Webhook URL
      </button>

      <button
        *ngIf="listWebhook"
        class="btn"
        style="width: 154px;"
        [ngClass]="isSaveDisabled ? 'btn-outline-secondary' : 'btn-primary text-white'"
        [disabled]="isSaveDisabled"
        (click)="submit()"
      >
        Save
      </button>
    </div>

    <div *ngIf="!isGetWebhook" class="overlay d-flex align-items-center justify-content-center">
      <nz-card style="width: 500px" nzHoverable class="flex flex-col items-center text-center p-4">
        <div class="flex flex-col items-center gap-2">
          <img src="https://storage.googleapis.com/komerce/assets/icons/warning.svg" alt="warning" width="90px" />
          <h6 class="text-bold mt-3" style="font-size: 20px">
            This Feature is for Enterprise Users Only
          </h6>
        </div>
        <span>
          To access advanced shipping features, upgrade to our Enterprise Package — designed for businesses that need more control, faster delivery management, and premium support.
        </span>
        <div class="flex align-items-center gap-3 w-full">
          <button class="btn btn-primary text-white w-100 mt-3 text-nowrap" (click)="upgradeToEnterprise()">
            <small>Upgrade to Enterprise</small>
          </button>
        </div>
      </nz-card>
    </div>
  </div>
</nz-card>
